<template>
    <div>
        <SearchForm :banner="banner" @search="search" :recaptcha_key="recaptcha_key"></SearchForm>
        <section class="wrap-billet-content" v-if="loading">
            <div class="row">
                <div class="small-12 medium-12 large-10 medium-centered columns">
                    <p>Carregando...</p>
                </div>
            </div>
        </section>
        <section class="wrap-billet-content" v-else-if="error">
            <div class="row">
                <div class="small-12 medium-12 large-10 medium-centered columns">
                    <p>{{ error }}</p>
                </div>
            </div>
        </section>
        <section class="wrap-billet-content" v-else-if="boletos.length == 0 && cpf_cnpj != ''">
            <div class="row">
                <div class="small-12 medium-12 large-10 medium-centered columns">
                    <p>Nenhum boleto encontrado.</p>
                </div>
            </div>
        </section>
        <SearchResult @atualizarVencimento="atualizarVencimento" :popup_simulacao="popup_simulacao" :banner_popup="banner_popup" :boletos="boletos" v-else-if="boletos.length != 0"></SearchResult>
        <div style="display:none">
            <div id="popup_parcele_clic">
                <a :href="url_clic" target="_blank">
                    <img :src="banner_popup" />
                </a>
            </div>
        </div>        
    </div>
</template>
<script>

import SearchForm from './components/SearchForm.vue';
import SearchResult from './components/SearchResult.vue';

export default {
    props: ['empresa', 'banner', 'banner_popup', 'recaptcha_key', 'popup_simulacao'],
    components: {
        SearchForm,
        SearchResult
    },
    data() {
        return {
            cpf_cnpj: '',
            loading: false,
            error: null
        }
    },
    computed: {
        boletos() {
            return this.$store.state.boletos;
        },
        
        url_clic() {
            let url = "https://www.vilarica.com.br/clic-web";
            if (/^(www\.)?vilarica\.com\.br$/igm.test(location.hostname)) {

            } else if (/^(www\.)?saoluiz\.imb\.br$/igm.test(location.hostname)) {
                url = "https://www.saoluiz.imb.br/sao-luis-web";
            }
            return url;
        }
    },
    methods: {
        async search(cpf_cnpj) {
            let empresa = this.empresa;
            this.loading = true;
            this.error = null;
            try {
                this.cpf_cnpj = cpf_cnpj;
                await this.$store.dispatch('getBoletos', {cpf_cnpj, empresa});
            } catch (err) {
                this.error = err.message;
                console.error(err);
            }
            this.loading = false;
            
        },
        atualizarVencimento() {
            this.search(this.cpf_cnpj);
        }
    }
}
</script>